import { Bike } from "./bike";
import { TaskAction } from "./taskAction";
import { TaskType } from "./taskType";

export interface Task {
    taskId: number | string;
    code: number | string;
    bike: string | null;
    type: string | null;
    status: string | null;
    action: number | string | null;
    notes?: string;
    bikeDetails?: Bike,
    typeDetails?: TaskType,
    statusDetails?: TaskStatus,
    actionDetails?: TaskAction,
    history?: TaskHistory[]
}


export interface TaskStatus {
    statusId: number | string;
    code: number | string;
    description: string;
    color: string;
}

export interface TaskHistory {
    historyId: number | string;
    taskId: number | string;
    field: string;
    oldValue: any;
    newValue: any;
    modifiedAt: Date;
    modifiedBy: string;
    modifiedByDetails: {
        firstName: string;
        lastName: string;
        userId: string;
        username: string;
        picture?: string;
    }
}

export interface TaskFilter {
    options: {
        status: any[],
        type: any[],
    },
    cache: {
        status: any[],
        type: any[],
    },
    values: {
        status?: string,
        type?: string,
        creationDate?: [Date | null | undefined, Date | null | undefined] | Date | null | undefined,
    },
    applied: {
        status?: string,
        type?: string,
        creationDate?: [Date | null | undefined, Date | null | undefined] | Date | null | undefined,
    }
}

export function getDefaultTask(): Task {
    return structuredClone({
        taskId: '',
        code: '',
        bike: null,
        type: null,
        status: "CREATED",
        action: null,
    })
}